import { z } from "zod";
const maxAllowedDomainLength = 253;
const domainLabelPattern = /^(?!-)[a-z0-9-]{1,63}(?<!-)$/u;
function normalizeAllowedDomain(domain) {
  return domain.trim().toLowerCase();
}
function checkIsIpv4Literal(hostname) {
  const labels = hostname.split(".");
  return labels.length === 4 && labels.every(
    (label) => /^\d{1,3}$/u.test(label) && Number(label) >= 0 && Number(label) <= 255
  );
}
function checkIsValidAllowedDomain(domain) {
  const normalized = normalizeAllowedDomain(domain);
  if (normalized.length === 0 || normalized.length > maxAllowedDomainLength || normalized.endsWith(".") || checkIsIpv4Literal(normalized)) {
    return false;
  }
  const labels = normalized.split(".");
  return labels.length >= 2 && labels.every((label) => domainLabelPattern.test(label));
}
const allowedDomainSchema = z.string().transform(normalizeAllowedDomain).pipe(
  // The check also covers the empty and over-length cases, so every failure
  // reports the same actionable message.
  z.string().refine(checkIsValidAllowedDomain, {
    message: "Enter a hostname only, without a scheme, path, port, wildcard, or IP address."
  })
);
export {
  allowedDomainSchema,
  checkIsValidAllowedDomain
};
//# sourceMappingURL=allowedDomain.js.map
